import {useCallback} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import styled from '@emotion/styled'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {getRoomOfferAnalyticsContexts} from 'middleware/analytics/selectors'
import {getIsOfferSoldOut} from 'modules/accommodation/selectors'
import {OverlayType} from 'modules/overlay/types'

import {ButtonLink} from '@vio/atlas/src/components/designSystem/ButtonLink'
import {Text} from '@vio/atlas/src/components/designSystem/Text'
import {cssTheme} from '@vio/atlas/src/themes'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  Page,
  Team
} from '@vio/core/src/analytics/types/Events'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

const SoldOutDealDetailsButton = styled(Text)`
  text-decoration: underline;
  text-underline-offset: ${cssTheme.layout.spacing.s200};
`
export const DealDetailsButton = ({
  offerId,
  bundleId,
  roomId,
  isFrozen = false
}: {
  offerId?: string
  bundleId?: string
  roomId?: string
  isFrozen?: boolean
}) => {
  const dispatch = useDispatch()
  const showOverlay = useShowOverlay()
  const isSoldOut = useSelector(state =>
    getIsOfferSoldOut(state, bundleId || offerId)
  )
  const analyticsContext = useSelector(state =>
    getRoomOfferAnalyticsContexts(state, bundleId || offerId)
  )
  const handleDealDetailsClick = useCallback(() => {
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.DealDetailsButton,
        action: Action.Clicked,
        team: Team.Select,
        page: Page.Accommodation,
        analyticsContext
      })
    )
    showOverlay({
      type: OverlayType.DealDetails,
      params: {
        roomId,
        offerId,
        bundleId,
        isFrozen
      }
    })
  }, [offerId, bundleId, roomId, showOverlay])

  if (isSoldOut) {
    return (
      <SoldOutDealDetailsButton
        variant="labelS"
        colorPath="content.neutral.disabled"
      >
        <FormattedMessageWrapper
          id="dealDetails.title"
          defaultMessage="Deal details"
        />
      </SoldOutDealDetailsButton>
    )
  }
  return (
    <ButtonLink
      onClick={handleDealDetailsClick}
      isCompact
      data-id="deal-details-button"
    >
      <Text variant="labelS">
        <FormattedMessageWrapper
          id="dealDetails.title"
          defaultMessage="Deal details"
        />
      </Text>
    </ButtonLink>
  )
}
